'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = require('./ListItem.scss');

var cn = _bind2.default.bind(styles);

var ListItem = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(ListItem, _Component);

  function ListItem() {
    (0, _classCallCheck3.default)(this, ListItem);
    return (0, _possibleConstructorReturn3.default)(this, (ListItem.__proto__ || (0, _getPrototypeOf2.default)(ListItem)).apply(this, arguments));
  }

  (0, _createClass3.default)(ListItem, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          isTitle = _props.isTitle,
          className = _props.className,
          fullWidth = _props.fullWidth,
          onClick = _props.onClick;

      var rootClass = cn(className, 'listItemRoot', { listItemTitle: isTitle, fullWidth: fullWidth });

      return _react2.default.createElement(
        'li',
        { className: rootClass, onClick: onClick },
        this.props.children
      );
    }
  }]);
  return ListItem;
}(_react.Component), _class.propTypes = {
  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
  className: _propTypes2.default.string,
  fullWidth: _propTypes2.default.bool,
  isTitle: _propTypes2.default.bool,
  onClick: _propTypes2.default.func
}, _temp);
exports.default = ListItem;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ListItem/ListItem.js
// module id = 76
// module chunks = 1